import classNames from 'classnames';
import React from 'react';
import styles from './TwoPanelLayout.module.css';
export var TwoPanelLayout = function (props) {
    var _a, _b, _c;
    var twoPanelClass = classNames(styles.twoPanelLayout);
    var rightPanelClass = classNames(styles.rightPanel, (_a = {},
        _a[styles.rightPanelOpen] = props.rightPanelOpen,
        _a));
    var leftPanelClass = classNames(styles.leftPanel, (_b = {},
        _b[styles.leftPanelOpen] = props.leftPanelOpen,
        _b[styles.noPadding] = props.noPadding,
        _b));
    var contentsPanelClass = classNames(styles.contentsPanel, (_c = {},
        _c[styles.contentsPanelLeftOpen] = props.leftPanelOpen,
        _c[styles.contentsPanelRightOpen] = props.rightPanelOpen,
        _c[styles.contentsLeft] = props.contentsLeft,
        _c));
    var contentMaskClass = classNames(styles.contentsMask);
    return (React.createElement(React.Fragment, null,
        props.header,
        React.createElement("main", { className: twoPanelClass },
            !!props.toolbar && React.createElement("div", { className: styles.toolbar }, props.toolbar),
            !!props.secondaryToolbar && React.createElement("div", { className: styles.secondaryToolbar }, props.secondaryToolbar),
            React.createElement("section", { className: styles.contentArea },
                React.createElement("aside", { className: leftPanelClass }, props.leftPanel),
                React.createElement("article", { className: contentsPanelClass },
                    props.contents,
                    props.children,
                    props.mask && React.createElement("div", { className: contentMaskClass })),
                props.rightPanel && React.createElement("aside", { className: rightPanelClass }, props.rightPanel)))));
};
